import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  backdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 9999,
    width: "100dvw",
    height: "100dvh",
    opacity: "0.75",
    backgroundColor: "#000",
  },
  imageWrapper: {
    cursor: "zoom-in",
    "&.active": {
      cursor: "zoom-out",
      position: "absolute",
      width: "100dvw",
      height: "100dvh",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
    },
  },
}));
